declare var ol: any;

export class RotateInteraction {
  private selectedFeatures: any;
  private pointerInteraction: any;

  private feature: any = null;
  private center: [number, number] | null = null;
  private startAngle: number | null = null;
  private baseGeometry: any = null;
  private rafPending = false;

  constructor(
    selectedFeatures: any,
    private select?: any,
    private translate?: any
  ) {
    const PointerCtor: any = (ol.interaction && (ol.interaction.Pointer || ol.interaction.PointerInteraction)) || null;
    if (!PointerCtor) throw new Error('ol.interaction.Pointer not available');

    const self = this;
    class RotatePointer extends PointerCtor {
      handleDownEvent(evt: any) {
        return self._down(evt);
      }
      handleDragEvent(evt: any) {
        return self._drag(evt);
      }
      handleUpEvent(evt: any) {
        return self._up();
      }
    }
    this.pointerInteraction = new RotatePointer();
    this.selectedFeatures = selectedFeatures;
  }

  public getInteraction(): any {
    return this.pointerInteraction;
  }

  private _down(evt: any): boolean {
    const feature = this.selectedFeatures.item(0);
    if (!feature) return false;

    const oe = evt.originalEvent || evt;
    const modifier = !!(oe.ctrlKey || oe.metaKey);
    if (!modifier) return false;

    this.feature = feature;
    const geom = feature.getGeometry();
    const extent = geom.getExtent();
    this.center = ol.extent.getCenter(extent) as [number, number];

    this.baseGeometry = geom;

    const [cx, cy] = this.center;
    const [x, y] = evt.coordinate as [number, number];
    this.startAngle = Math.atan2(y - cy, x - cx);

    this.rafPending = false;

    this.select?.setActive?.(false);
    this.translate?.setActive?.(false);

    return true;
  }

  private _drag(evt: any): void {
    if (!this.feature || !this.center || this.startAngle == null || !this.baseGeometry) return;

    const [cx, cy] = this.center;
    const [x, y] = evt.coordinate as [number, number];
    const angle = Math.atan2(y - cy, x - cx) - this.startAngle;

    if (this.rafPending) return;
    this.rafPending = true;

    requestAnimationFrame(() => {
      const geom = this.baseGeometry.clone();
      geom.rotate(angle, this.center);
      this.feature.setGeometry(geom);

      this.rafPending = false;
    });
  }

  private _up(): boolean {
    this.feature = null;
    this.center = null;
    this.startAngle = null;
    this.baseGeometry = null;
    this.rafPending = false;

    this.select?.setActive?.(true);
    this.translate?.setActive?.(true);

    return false;
  }
}
